let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("kft0l")).then(() => parcelRequire('6LTAU'));